import { gql } from "@apollo/client";

const MISSING_NORMALIZED_PATHS = gql`
  query Missing($clientId: ID!, $paths: [String!]!, $taxYear: Int, $ignore: [String!]) {
    missingNormalizedPaths(
      clientId: $clientId
      normalizedPaths: $paths
      taxYear: $taxYear
      ignoreIfAbsent: $ignore
    ) {
      summary {
        presentMissingCount
        presentTotalCount
        presentCompletenessPercent
      }
      groups {
        basePath
        label
        category
        missingCount
        totalCount
        allMissing
        missingFields {
          field
          label
          fullPath
        }
        missingInArrays {
          index
          missingFields {
            field
            label
            fullPath
          }
        }
        children {
          basePath
          label
          missingCount
          totalCount
          allMissing
        }
      }
    }
  }
`;

export default MISSING_NORMALIZED_PATHS;
